/**
 * Tailwind CSS implementation of SpotIllustration component
 * Uses Seeds spot-illustration CSS classes from spot-illustration.css
 */

import React from "react";
import type { TypeSpotIllustrationProps } from "./SpotIllustrationTypes";
import { ViewBoxes } from "@sproutsocial/seeds-illustrations";

// Utility for merging class names properly
function cn(
  ...inputs: (string | undefined | null | false | Record<string, boolean>)[]
): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === "string") {
      classes.push(input);
    } else if (typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}

export const SpotIllustrationTailwind = ({
  name,
  customFill,
  height,
  width,
  className,
  ...svgProps
}: TypeSpotIllustrationProps) => {
  const viewBox = ViewBoxes[name];
  const viewBoxCoordinates = viewBox?.split(" ") || [];
  const defaultWidth = viewBoxCoordinates[2];
  const defaultHeight = viewBoxCoordinates[3];

  const hasAriaLabel = !!svgProps["aria-label"];
  const ariaHidden = svgProps["aria-hidden"] ?? !hasAriaLabel;
  const ariaProps = ariaHidden
    ? { "aria-hidden": ariaHidden, "aria-label": undefined }
    : { role: "img" };

  return (
    <svg
      className={cn(
        "seeds-spot-illustration",
        customFill && `seeds-spot-illustration-${customFill}`,
        className
      )}
      {...svgProps}
      width={width ? width : defaultWidth}
      height={height ? height : defaultHeight}
      viewBox={viewBox}
      focusable={false}
      {...ariaProps}
    >
      <use
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xlinkHref={`#seeds-svgs_${name}`}
      />
    </svg>
  );
};

SpotIllustrationTailwind.displayName = "SpotIllustrationTailwind";
